import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose, bindActionCreators } from 'redux'
import { trackPromise } from 'react-promise-tracker'
import cookie from 'react-cookies'

import { hasDiet, litOfDiets, setDiet } from '../../../Api/dietApi/userInfo'

import ChooseDietScreen from './ChooseDietScreen.tsx'

class ChooseDietScreenContainer extends Component {
  static propTypes = {}

  state = {
    // isDemoAccount: cookie.load('userDemoMode'),
    challengeMode: this.props.location.challengeMode
  }

  componentDidMount = async () => {
    // if (this.state.isDemoAccount) {
    //   this.props.history.push('/trening')
    // }
    await this.checkIfUserHasDiet()
    await this.getListOfDiets()
    await this.redirectIfUserHasDiet()
  }

  redirectIfUserHasDiet = () => {
    if (this.state.userHasDiet && !this.props.location.userChangeDiet) {
      this.props.history.push({
        pathname: `/dieta`,
      })
    }
  }

  checkIfUserHasDiet = async () => {
    const userDietiet = await trackPromise(hasDiet())

    this.setState({
      userHasDiet: userDietiet,
    })
  }

  getListOfDiets = async () => {
    const diets = await trackPromise(litOfDiets())

    this.setState({
      diets: diets,
    })
  }

  goToCalculator = async (dietId) => {
    await setDiet(dietId)
    await this.props.history.push({
      pathname: `/kalkulator`,
      dietId: dietId,
      creationDietMode: true,
      challengeMode: this.state.challengeMode
    })
  }

  render() {

    return (
      <ChooseDietScreen
        diets={this.state.diets}
        goToCalculator={this.goToCalculator}
        isDemoAccount={this.state.isDemoAccount}
        challengeMode={this.state.challengeMode}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    diet: state.diet,
  }
}

// function mapDispatchToProps(dispatch) {
//   return {
//     dietActions: bindActionCreators(dietActions, dispatch),
//   }
// }

export default compose(
  withRouter,
  connect(mapStateToProps)
)(ChooseDietScreenContainer)
